import { Divider } from "@mui/material"
import React from "react"

const FormDivider = () => (
    <Divider variant="fullWidth" sx={{ borderColor: "primary.main", borderWidth: "1px", mt: "8px" }}></Divider>
)

export default FormDivider;
